import { Box, styled, Tooltip } from '@mui/material';
import { IconInfoRedesigned } from 'assets/img';
import { useTranslation } from 'react-i18next';

export const EmployeeContractStartDateInfoTooltip = () => {
  const { t } = useTranslation('ogp-screen-specific');

  return (
    <Tooltip title={t('employee-contract-start-date-info', { ns: 'ogp-screen-specific' })}>
      <Box display="flex" alignItems="center">
        <IconInfoRedesignedStyled
          width={'20px'}
          height={'20px'}
          data-testid="contract-start-info-icon"
        />
      </Box>
    </Tooltip>
  );
};

const IconInfoRedesignedStyled = styled(IconInfoRedesigned)(({ theme }) => ({
  '& path': {
    stroke: theme.palette.lwBlack[60],
    transition: 'stroke 0.2s ease',
  },
  '&:hover path': {
    stroke: theme.palette.lwBlack[100],
  },
}));
